/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import { RelatedStories } from "../../story-page-components/related-stories";
import { AdService } from "../../ad-service";
import { isRelatedStoriesExtraAdSlotEnabled } from "../../../../utils/relatedStoriesAdSlot";
import "./sidebar.module.css";

const MrecAd = id => {
  return (
    <div styleName="ad">
      <AdService adtype="Story-Mrec" slotId={id} shouldRefreshOnce />
    </div>
  );
};

export const Sidebar = ({ story, showAd, template, wide, config, publisherConfig, index }) => {
  return (
    <>
      {!showAd ? null : (
        <React.Fragment>
          <MrecAd id={`Sidebar-${index}`} />
          {isRelatedStoriesExtraAdSlotEnabled(publisherConfig, config) && <MrecAd id={`Sidebar_below-${index}`} />}
        </React.Fragment>
      )}
      <RelatedStories template={template} story={story} wide={wide} config={config} />
    </>
  );
};

Sidebar.propTypes = {
  story: PropTypes.object,
  showAd: PropTypes.bool,
  template: PropTypes.string,
  wide: PropTypes.bool,
  config: PropTypes.object,
  publisherConfig: PropTypes.object,
  index: PropTypes.number
};
